<template>
    <div class="match-team-game-battle-array">
        <!-- head start -->
        <div class="head">
            <game-summary
                :title="gameInfo.title"
                :time="gameInfo.time"
                :homeTeamName="gameInfo.homeTeamName"
                :homeTeamBadge="gameInfo.homeTeamBadge"
                :awayTeamName="gameInfo.awayTeamName"
                :awayTeamBadge="gameInfo.awayTeamBadge">
            </game-summary>
        </div>
        <!-- content start -->
        <div class="content">
            <div class="tabs">
              <van-tabs v-model="active" color="#0FAC7F" title-active-color="#0FAC7F" @change="onTabChange">
                <van-tab title="比赛事件">
                  <div class="event-list">
                    <div v-for="item in events" :key="item.type" >
                      <div class="event-item-time flex-center">{{ item.name }} <span @click="item.show = !item.show">{{ item.show ? '折叠' : '展开' }}</span></div>
                      <div class="event-item-content" v-if="item.show">
                        <div v-for="event in item.list" :key="event.id" class="flex-center event-item-content-item">
                          <div class="team-name">{{ event.teamId === gameInfo.homeTeamId ? gameInfo.homeTeamName : gameInfo.awayTeamName }}</div>
                          <div class="info">
                            <span>{{ event.userNumber }}</span>
                            {{ event.userName }}
                          </div>
                          <div class="time">{{ event.time }}'</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </van-tab>
                <van-tab title="裁判员评估">
                  <div class="assessment">
                    <div class="form">
                      <div class="form-item flex-center" @click="showAttitudePicker = true">
                        <div class="label"><span>*</span>执法态度</div>
                        <div class="value">
                          {{ attitudeText || '请选择' }}
                          <van-icon name="arrow" />
                        </div>
                      </div>
                      <div class="form-item flex-center" @click="showPerformancePicker = true">
                        <div class="label"><span>*</span>整体表现</div>
                        <div class="value">
                          {{ performanceText || '请选择' }}
                          <van-icon name="arrow" />
                        </div>
                      </div>
                      <div class="form-item-textarea">
                      <div class="label">裁判评估备注</div>
                      <div class="textarea">
                        <textarea v-model="aboutRefereeRemark" placeholder="请输入裁判评估备注" />
                      </div>
                      </div>
                      <div class="form-item-textarea">
                        <div class="label">运动队违纪违规情况</div>
                        <div class="textarea">
                          <textarea v-model="playerFoulSituation" placeholder="请输入运动队违纪违规情况" />
                        </div>
                      </div>
                      <div class="form-item-textarea">
                        <div class="label">比赛备注</div>
                        <div class="textarea">
                          <textarea v-model="gameRemark" placeholder="请输入比赛备注" />
                        </div>
                      </div>
                    </div>
                    <!-- 执法态度 Picker -->
                    <van-popup v-model="showAttitudePicker" position="bottom">
                      <van-picker
                        show-toolbar
                        :columns="attitudeOptions"
                        @confirm="onAttitudeConfirm"
                        @cancel="showAttitudePicker = false"
                      />
                    </van-popup>
                    <!-- 整体表现 Picker -->
                    <van-popup v-model="showPerformancePicker" position="bottom">
                      <van-picker
                        show-toolbar
                        :columns="performanceOptions"
                        @confirm="onPerformanceConfirm"
                        @cancel="showPerformancePicker = false"
                      />
                    </van-popup>
                  </div>
                </van-tab>
                <van-tab title="比赛信息">
                  <div class="assessment">
                    <div class="form">
                      <div class="form-item flex-center">
                        <div class="label">观众人数</div>
                        <div class="value">
                          <input type="number" v-model="spectatorCount" placeholder="请输入观众人数" />
                        </div>
                      </div>
                      <div class="form-item flex-center">
                        <div class="label">天气</div>
                        <div class="value">
                          <input type="text" v-model="weather" placeholder="请输入天气情况" />
                        </div>
                      </div>
                      <div class="form-item flex-center">
                        <div class="label">气温</div>
                        <div class="value">
                          <input type="text" v-model="temperature" placeholder="请输入气温情况" />
                        </div>
                      </div>
                      <div class="form-item-textarea">
                        <div class="label">比赛情况</div>
                        <div class="textarea">
                          <textarea v-model="gameSituation" placeholder="请输入比赛情况" />
                        </div>
                      </div>
                    </div>
                  </div>
                </van-tab>
              </van-tabs>
            </div>
        </div>
        <FooterBtn :btnText="btnText" :disable="!canSubmit || disable" :showDisable="showDisable" :disableLabel="disableLabel" :disableValue="disableValue" @click="submitReport" />
    </div>
</template>

<script>
import GameSummary from './game-summary.vue'
import { getPassport } from '@/libs/passport'
import { getGameDetail, adminGetBMGameSupervisionReport,updateBMGameSupervisionReport } from '@/api/match-team-game'
import { DateUtil } from '@/utils'
import Vue from 'vue'
import { Tab, Tabs, Picker, Popup } from 'vant'
Vue.use(Tab).use(Tabs);
Vue.use(Picker).use(Popup)
import FooterBtn from './footer-btn.vue'
export default {
    components: {
      GameSummary,
      FooterBtn
    },
    data() {
        return {
          /* The game info */
          gameInfo: {
              /* The title string */
              title: null,
              /* The time string */
              time: null,
              /* The home team id */
              homeTeamId: null,
              /* The home team name */
              homeTeamName: null,
              /* The home team badge */
              homeTeamBadge: null,
              /* The away team id */
              awayTeamId: null,
              /* The away team name */
              awayTeamName: null,
              /* The away team badge */
              awayTeamBadge: null
          },
          events: [],
          active: 0,
          showAttitudePicker: false,
          showPerformancePicker: false,
          refereeAttitude: '', // 选中的执法态度
          refereePerformance: '', // 选中的整体表现
          aboutRefereeRemark: '', // 裁判评估备注
          playerFoulSituation: '', // 运动队违纪违规情况
          gameRemark: '', // 比赛备注
          spectatorCount: 0, // 观众人数
          weather: '', // 天气情况
          temperature: '', // 气温情况
          gameSituation: '', // 比赛情况
          attitudeOptions: ['优秀', '良好', '及格', '不及格'],
          performanceOptions: ['优秀', '良好', '表现一般', '需要提高'],
          visitedTabs: [], // 记录用户访问过的tabs
          disable: false,
          disableLabel: '',
          disableValue: '',
          btnText: '提交报告',
          showDisable: false
        }
    },
    computed: {
      attitudeText() {
        return this.refereeAttitude
      },
      performanceText() {
        return this.refereePerformance
      },
      // 判断是否启用提交按钮
      canSubmit() {
        return this.visitedTabs.length >= 3
      }
    },
    created() {
        // validate the passport and prepair the one
        getPassport().then(res => {
            console.log('getPassport', res)
            if (res) {
              this.queryGameInfo()
              this.queryGameSupervisionReport()
            }
        })
        // 初始化时记录第一个tab
        this.visitedTabs.push(0)
	},
    methods: {
      queryGameInfo() {
            const routerParams = this.$route.params
            const params = {
                gameId: routerParams.gameId,
                eventMode: 0,
                simple: 0
            }
            getGameDetail(params).then(response => {
                console.log("get game detail response", response)
                const data = response.data
                // set the game info data
                let title = data.game.matchName
                if (data.game.gameType) {
                    title += ' | ' + data.game.gameType
                }
                if (data.game.roundDescription) {
                    title += ' | ' + data.game.roundDescription
                }
                this.gameInfo.title = title
                const weekDay = DateUtil.parseDateTime(data.game.beginDate, '{a}')
                console.log('weekDay', weekDay)
                const startTime = DateUtil.parseDateTime(data.game.beginDate, '{y}-{m}-{d} {h}:{i}')
                const endTime = DateUtil.parseDateTime(data.game.endDate, '{h}:{i}')
                this.gameInfo.time = '周' + weekDay + ' ' + startTime + '~' + endTime
                this.gameInfo.homeTeamId = data.game.homeTeamId
                this.gameInfo.homeTeamName = data.game.homeTeamName
                this.gameInfo.homeTeamBadge = data.game.homeTeamBadge
                this.gameInfo.awayTeamId = data.game.awayTeamId
                this.gameInfo.awayTeamName = data.game.awayTeamName
                this.gameInfo.awayTeamBadge = data.game.awayTeamBadge
                if (routerParams.teamId === data.game.homeTeamId) {
                    this.type = 'home'
                    this.title = this.gameInfo.homeTeamName
                    if (data.game.homeClothesColors) {
                        const clothesColors = JSON.parse(data.game.homeClothesColors)
                        this.clothesColors = Object.values(clothesColors.teamColor).map(item => {
                            return item
                        }).join('、')
                    }
                } else {
                    this.type = 'away'
                    this.title = this.gameInfo.awayTeamName
                    if (data.game.awayClothesColors) {
                        const clothesColors = JSON.parse(data.game.awayClothesColors)
                        this.clothesColors = Object.values(clothesColors.teamColor).map(item => {
                            return item
                        }).join('、')
                    }
                }
            })
      },
      queryGameSupervisionReport() {
        const routerParams = this.$route.params
        const params = {
            gameId: routerParams.gameId,
            matchId: routerParams.matchId
        }
        adminGetBMGameSupervisionReport(params).then(response => {
          const events = response.data.events || []

          // 分组逻辑
          const typeMap = {
            goal: { group: 'goal', name: '进球' },
            penalty: { group: 'goal', name: '进球' },
            ownGoal: { group: 'goal', name: '进球' },
            yellow: { group: 'yellow', name: '黄牌' },
            red: { group: 'red', name: '红牌' },
            leaveBench: { group: 'leaveBench', name: '罚离替补席' }
          }
          const groupObj = {}
          const yellowCountMap = {}

          // 先统计每个人的 yellow 事件数量
          events.forEach(item => {
            if (item.type === 'yellow') {
              yellowCountMap[item.playerId] = (yellowCountMap[item.playerId] || 0) + 1
              console.log('yellowCountMap', yellowCountMap)
            }
          })

          // 分组
          events.forEach(item => {
            const map = typeMap[item.type]
            if (map) {
              const key = map.group
              if (!groupObj[key]) {
                groupObj[key] = { type: key, name: map.name, list: [], show: true }
              }
              groupObj[key].list.push(item)
            }
          })

          // 对 yellow 分组做特殊处理：移除有两张黄牌的人的 yellow 事件
          if (groupObj.yellow) {
            groupObj.yellow.list = groupObj.yellow.list.filter(item => yellowCountMap[item.playerId] < 2)
          }

          const grouped = Object.values(groupObj)
          // 按照指定顺序排序
          const order = ['goal', 'yellow', 'red', 'leaveBench']
          grouped.sort((a, b) => order.indexOf(a.type) - order.indexOf(b.type))

          this.events = grouped

          const report = response.data.report
          if (report.refereeAttitude) {
            this.refereeAttitude = report.refereeAttitude
            this.refereePerformance = report.refereePerformance
            this.aboutRefereeRemark = report.aboutRefereeRemark
            this.playerFoulSituation = report.playerFoulSituation
            this.gameRemark = report.gameRemark
            this.spectatorCount = report.spectatorCount
            this.weather = report.weather
            this.temperature = report.temperature
            this.gameSituation = report.gameSituation
            this.disableLabel = '已提交'
            // 用户昵称用户昵称于05/25 15:45完成比赛监督报告提交
            this.disableValue =  report.createUserName + '于' + DateUtil.parseDateTime(report.createDate, '{m}/{d} {h}:{i}') + '完成比赛监督报告提交'
            this.btnText = '报告已提交'
            this.disable = true
            this.showDisable = true
          }
          console.log(grouped)
        })
      },
      onAttitudeConfirm(value) {
        this.refereeAttitude = value
        this.showAttitudePicker = false
      },
      onPerformanceConfirm(value) {
        this.refereePerformance = value
        this.showPerformancePicker = false
      },
      // 处理tab切换事件
      onTabChange(index) {
        // 记录用户访问过的tab
        if (!this.visitedTabs.includes(index)) {
          this.visitedTabs.push(index)
        }
      },
      submitReport() {
        console.log('submitReport')
        if (!this.refereeAttitude) {
          this.$toast('请选择执法态度')
          this.active = 1
          return
        }
        if (!this.refereePerformance) {
          this.$toast('请选择整体表现')
          this.active = 1
          return
        }
        const params = {
          gameId: this.$route.params.gameId,
        }
        const data = {
          refereeAttitude: this.refereeAttitude,
          refereePerformance: this.refereePerformance,
          aboutRefereeRemark: this.aboutRefereeRemark,
          playerFoulSituation: this.playerFoulSituation,
          gameRemark: this.gameRemark,
          spectatorCount: this.spectatorCount,
          weather: this.weather,
          temperature: this.temperature,
          gameSituation: this.gameSituation
        }
        updateBMGameSupervisionReport(params, data).then(response => {
          console.log('updateBMGameSupervisionReport response', response)
          if (response) {
            this.$toast('提交成功')
            this.$router.go(-1)
          }
        })
      }
    },
};
</script>

<style scoped lang="scss">
::v-deep .van-tabs__nav{
  background-color: #F8F8F8;
}
.match-team-game-battle-array{
  background-color: #F8F8F8;
  min-height: 100vh;
  padding-bottom: 12px;
  box-sizing: border-box;
    .head{
        background-color: #fff;
    }
    .content{
      .tabs{
        width: 300px;
        .event-list{
          width: 100vw;
          .event-item-time{
            background: #F0F0F3;
            margin-top: 5px;

            padding: 0 16px;
            height: 38px;
            line-height: 38px;
            font-size: 14px;
            color: #676767;
            span{
              font-size: 12px;
              color: #0FAC7F;
            }
          }
          .event-item-content-item{
            height: 40px;
            margin-bottom: 5px;
            background-color: #fff;
            padding-left: 22px;
            padding-right: 17px;
            .team-name{
              font-size: 12px;
              color: #999999;
            }
            .info{
              flex: 1;
              margin-left: 40px;
              font-size: 14px;
              color: #3D3D3D;
              span{
                display: inline-block;
                border: 1px solid #0FAC7F;
                width: 20px;
                height: 20px;
                border-radius: 3px;
                text-align: center;
                line-height: 20px;
                margin-right: 8px;
              }
            }
            .time{
              font-size: 11px;
            }
          }
        }
        .assessment{
          width: 100vw;
          padding: 10px;
          box-sizing: border-box;
          .form{
            font-size: 15px;
            color: #666666;
            .form-item{
              margin-bottom: 5px;
              height: 50px;
              border-radius: 5px;
              background: #FFFFFF;
              padding: 0 14px;
              .label{
                span{
                  color: #0FAC7F;
                  margin-right: 4px;
                }
              }
              .value{
                color: #535353;
                input{
                  width: 100%;
                  height: 100%;
                  border: none;
                  text-align: right;
                }
              }
            }
            .form-item-textarea{
              margin-bottom: 5px;
              border-radius: 5px;
              background: #FFFFFF;
              padding: 14px;
              .textarea{
                margin-top: 8px;
                padding-left: 15px;
                height: 100px;
                textarea{
                  width: 100%;
                  height: 100px;
                  border: none;
                }
              }
            }
          }
        }
      }
    }
}
</style>
